export default __webpack_public_path__ + "static/media/verification-failed.70148054.svg";